module.exports = __webpack_public_path__ + "img/cm.d91f2e84.svg";